import script from "./DownloadResource.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadResource.vue?vue&type=script&setup=true&lang=ts"

import "./DownloadResource.vue?vue&type=style&index=0&id=4c5d4ba7&lang=scss"

const __exports__ = script;

export default __exports__